import { TMinMaxFromGYPMerchant } from '@/src/modules/build-a-card/types'
import { formatAmountForDisplay } from '@/src/common/utilities/currencyFormatter'
import { EGIFT } from '@/src/modules/gyp/gyp_redemption_methods'

// build out types as more options available
function determineValidDenomText(
    minMaxAndFixed: TMinMaxFromGYPMerchant,
    type: typeof EGIFT = EGIFT
) {
    const { brand_min, brand_max } = minMaxAndFixed
    let minDenom = brand_min
    let maxDenom = brand_max
    let fixedDenoms: number[] = []

    if (type === EGIFT) {
        const egiftDenoms = minMaxAndFixed?.egift

        // set variable values based on egift
        fixedDenoms = egiftDenoms?.fixed ?? fixedDenoms
        minDenom = egiftDenoms?.min ?? brand_min
        maxDenom = egiftDenoms?.max ?? brand_max
    }

    if (fixedDenoms?.length) {
        let validDenoms: string = ''
        const valuesText: string = fixedDenoms?.length > 1 ? 'values' : 'value'

        fixedDenoms?.forEach((denom: number, index: number) => {
            const isNotLastItem: boolean = index !== fixedDenoms.length - 1

            validDenoms += `${formatAmountForDisplay(denom, 'USD')}${
                isNotLastItem ? ', ' : ''
            }`
        })

        return `${validDenoms} ${valuesText} only`
    }

    const hasMinAndMax: boolean = !!minDenom && !!maxDenom

    const formattedMin: string = formatAmountForDisplay(minDenom, 'USD')
    const formattedMax: string = formatAmountForDisplay(maxDenom, 'USD')

    const minText: string = minDenom ? `min: ${formattedMin}` : ''
    const maxText: string = maxDenom ? `max: ${formattedMax}` : ''
    const comma: string = hasMinAndMax ? ', ' : ''

    return `${minText}${comma} ${maxText}`.trim()
}

export default determineValidDenomText
